// ** React Imports
import React, {ReactNode, useEffect, useMemo} from 'react'

// ** MUI Imports
import { Theme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

// ** Layout Imports
// !Do not remove this Layout import
import Layout from 'src/@core/layouts/Layout'


// ** Hook Import
import { useSettings } from 'src/@core/hooks/useSettings'
import { Settings } from 'src/@core/context/settingsContext'
import {NavLink, VerticalNavItemsType} from 'src/@core/layouts/types'
import HeaderContent from './components/HeaderContent'
import { Accion } from '../types'
import { EntityWithIdAndDescription } from 'src/types'
import {MensajeDetalle, MensajeFields} from 'src/pages/messages/types'
import {useOperacion} from "../hooks/useOperacion";
import {useArchivos} from "../hooks/useArchivos";
import {useComentarios} from "../hooks/useComentarios";

interface Props {
    children: ReactNode
    message: MensajeDetalle
    contentHeightFixed?: boolean
    acciones: {
        isNewOperacion: boolean
        saveHandler?: () => void
        closeHandler?: () => void
        cancelHandler?: () => void
        printHandler?: () => void
        actionsOptions?: Accion[]
        actionsHandler: (seleccion: EntityWithIdAndDescription) => void
    }
}

const OperacionLayout = ({ children, contentHeightFixed, acciones, message }: Props) => {
    // ** Hooks
    const { settings, saveSettings } = useSettings()
    const { archivos, status, refetch } = useArchivos(message[MensajeFields.OperacionId], message[MensajeFields.CodSistemaTipo])
    const { comentarios, status: statusComentarios, refetch: refetchComentarios } = useComentarios( message[MensajeFields.CodSistemaTipo], message[MensajeFields.OperacionId])

    const operacionLayoutSettings: Settings = {
        ...settings,
        layout: 'vertical',
        appBar: 'fixed' //'fixed' TODO: header a appbar
    }

    const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

    // Si se llega a necesitar definir por tipo de sistema, se puede hacer un switch

    const navItems:VerticalNavItemsType = useMemo(() => [
        {
            title: 'Planilla de Carga',
            icon: 'tabler:clipboard-data',
            path: ``,
        },
        {
            title: 'Comentarios',
            icon: 'mdi:comments-text-outline',
            path: `comentarios`,
            replaceState: true,
          ...((comentarios?.length ?? 0) > 0 && {
            badgeContent: comentarios?.length.toString(),
            badgeColor: 'error'
          })

        },
        {
            title: 'Documentación',
            icon: 'humbleicons:documents',
            path: `documentos`,
            replaceState: true,
          ...((archivos?.length ?? 0) > 0 && {
            badgeContent: archivos?.length.toString(),
            badgeColor: 'error'
          })
        }
    ], [archivos, comentarios])

    return (
        <Layout
            hidden={isSmallScreen}
            settings={operacionLayoutSettings}
            saveSettings={saveSettings}
            contentHeightFixed={contentHeightFixed}
            verticalLayoutProps={{
                navMenu: {
                    navItems: navItems
                },
                appBar: {
                    content: props => (
                        <HeaderContent
                            message={message}
                            hidden={isSmallScreen}
                            settings={operacionLayoutSettings}
                            toggleNavVisibility={props.toggleNavVisibility}
                            acciones={acciones}
                        />
                    )
                }
            }}
        >

            <>
              {children}
            </>
        </Layout>
    )
}

export type HeaderProps = {
    message: MensajeDetalle
    acciones: {
        isNewOperacion: boolean
        saveHandler?: () => void
        closeHandler?: () => void
        cancelHandler?: () => void
        printHandler?: () => void
        actionsOptions?: Accion[]
        actionsHandler: (seleccion: EntityWithIdAndDescription) => void
    }
}

export default OperacionLayout
